import {OrderIntakeOption, OrderRequest} from '../../../declarations/types'
import {
  getTodaysCutOffTime,
  isCurrentTimeAfterCutOff,
  isDateAvailable
} from '../../../../Organisms/OrderIntake/utils'
import some from 'lodash/some'

interface ValidationResult {
  validatedOrders: OrderRequest[]
  hasUnavailableDates: boolean
}

export const validateDeliveryDates = (
  orders: OrderRequest[],
  selectedSite: OrderIntakeOption
): ValidationResult => {
  const validatedOrders = orders.map((delivery) => {
    const materialKey = delivery.payload.materialEnteredNumber
    const defaultMaterialOption = selectedSite.materials[materialKey][0]

    const businessDays = defaultMaterialOption.dateRange?.businessDays ?? []
    const todaysCutOffTime = getTodaysCutOffTime(businessDays)[0].cutOffTime
    const cutOffTimeStamp = todaysCutOffTime?.timestamp
    const timeZone = defaultMaterialOption.businessHours?.timeZone

    const isPastCutOff = cutOffTimeStamp
      ? isCurrentTimeAfterCutOff(cutOffTimeStamp, timeZone)
      : false

    const isDateStillAvailable = isDateAvailable(
      delivery.payload.deliveryDate,
      defaultMaterialOption.dateRange,
      timeZone
    )

    return {
      ...delivery,
      isDateNotAvailable: isPastCutOff && !isDateStillAvailable
    }
  })

  return {
    validatedOrders,
    hasUnavailableDates: some(validatedOrders, 'isDateNotAvailable')
  }
}
